import * as React from 'react';
import { observer } from 'mobx-react';
import { injectTSDI } from '../../core/tsdi';
import { I18nStore } from '../../core/i18n-store';
import { CookieInfo } from './index';

export const GooglePolicy: React.ComponentType = (props) => (
    <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer"
    >
        {props.children}
    </a>
);

export const FacebookPolicy: React.ComponentType = (props) => (
    <a
        href="https://www.facebook.com/business/gdpr"
        target="_blank"
        rel="noreferrer"
    >
        {props.children}
    </a>
);

interface CookieTableProps {
    name: string;
    rows: CookieInfo[];
}

export const CookieTable = observer((props: CookieTableProps) => {
    const { translate } = injectTSDI(I18nStore);

    const anyHasExpiration = props.rows.some((row) => row.expiration);

    return (
        <article>
            <b> {props.name}</b>
            <table className="cookienotice__table">
                <thead>
                    <tr>
                        <th>{translate('onlinepages.cookies.name')}</th>
                        <th>{translate('onlinepages.cookies.providers')}</th>
                        {anyHasExpiration && (
                            <th>
                                {translate('onlinpeages.cookies.expiration')}
                            </th>
                        )}
                        <th>{translate('onlinepages.cookies.purpose')}</th>
                    </tr>
                </thead>
                <tbody>
                    {props.rows.map((row) => (
                        <tr key={row.name}>
                            <td>{row.name}</td>
                            <td>{row.providers}</td>
                            {anyHasExpiration && <td>{row.expiration}</td>}
                            <td>{row.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </article>
    );
});
